<template>
  <div class="result-card">
    <a :href="result.url" class="result-card__image" :style="'background-image: url(' + result.image + ')'"/>
    <div class="result-card__info">
      <a :href="result.url" class="result-card__info__title">
        {{result.name}}
      </a>
      <div class="result-card__info__description">
        {{result.description}}
      </div>
      <a v-if="result.download_url"
        :href="result.download_url"
        download="questionnaire_result"
        target="_blank"
        class="result-card__info__download-btn">
        Download
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.result-card {
  display: flex;
  align-items: center;
  text-align: left;
  max-width: 660px;
  background: white;
  box-shadow: 0 1px 6px rgba(80, 179, 237, 0.2);
  margin: 12px;
  border-radius: 8px;
  overflow: hidden;

  .result-card__image {
    display: block;
    flex: 1;
    min-width: 285px;
    max-width: 285px;
    height: 190px;
    background-size: cover;
  }

  .result-card__info {
    flex: 1;
    padding: 28px;

    .result-card__info__title {
      display: block;
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 12px;
      color: inherit;
      text-decoration: none;
    }

    .result-card__info__description {
      opacity: 0.6;
      font-size: 14px;
    }

    .result-card__info__download-btn {
      display: inline-block;
      padding: 8px 16px;
      margin-top: 12px;
      background: #1abc9c;
      color: white;
      border-radius: 6px;
      text-decoration: none;
      cursor: pointer;

      &:hover {
        background: #1abc9c;
      }
    }
  }

  @media screen and (max-width: 760px) {
    display: inline-block;
    max-width: 285px;
    vertical-align: top;
  }
}
</style>
